import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InfraNav from './components/InfraNav';
import './infrastructure.css';

export default function InfrastructureHome() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', company: '', product: '' });

  return (
    <div className="infra-page" data-testid="infrastructure-home">

      {/* ═══ 1. NAV ═══ */}
      <InfraNav transparent={true} />

      {/* ═══ 2. DARK HERO ═══ */}
      <div className="infra-hero" data-testid="infra-hero">
        <div className="infra-hero-grid-bg" />
        <div className="infra-hero-bars">
          <div className="infra-hero-bar" style={{ height: 90, background: '#FF2D8A' }} />
          <div className="infra-hero-bar" style={{ height: 170, background: '#1D9E75' }} />
          <div className="infra-hero-bar" style={{ height: 130, background: '#7F77DD' }} />
          <div className="infra-hero-bar" style={{ height: 210, background: '#D85A30' }} />
          <div className="infra-hero-bar" style={{ height: 110, background: '#4158D0' }} />
        </div>
        <div className="infra-hero-content">
          <div>
            <div className="infra-hero-eyebrow">FINANCIAL OPERATING SYSTEM</div>
            <h1 className="infra-hero-headline">The <span className="infra-underline">financial</span> OS companies build on.</h1>
            <p className="infra-hero-subtitle">Pay employees, move money, collect recurring payments, verify identities, and power third-party integrations from a single platform.</p>
            <div className="infra-hero-buttons">
              <Link to="/login" className="infra-btn-primary" data-testid="hero-get-started">Get started</Link>
              <a href="mailto:hello@thcohq.com" className="infra-btn-secondary" data-testid="hero-contact-sales">Contact sales</a>
            </div>
          </div>
          <div className="infra-hero-dashboard" data-testid="hero-dashboard">
            <div className="infra-hero-tiles">
              {[
                { color: '#FF2D8A', name: 'Payroll', stat: '\u20A64.2M processed' },
                { color: '#1D9E75', name: 'Wallets', stat: '1,247 active' },
                { color: '#7F77DD', name: 'Collect', stat: '99.1% success' },
                { color: '#D85A30', name: 'Connect', stat: '12 partners' },
                { color: '#888780', name: 'Comply', stat: 'All verified' },
                { color: '#4158D0', name: 'Agents', stat: '3 active' },
              ].map((t, i) => (
                <div key={i} className="infra-hero-tile">
                  <div className="infra-hero-tile-top">
                    <div className="infra-hero-tile-dot" style={{ background: t.color }} />
                    <span className="infra-hero-tile-name">{t.name}</span>
                  </div>
                  <div className="infra-hero-tile-stat">{t.stat}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ═══ 3. INTRO TEXT ═══ */}
      <div className="infra-intro" data-testid="infra-intro">
        <div className="infra-intro-grid">
          <div className="infra-intro-left">
            <h2 className="infra-intro-heading">Powering businesses of all sizes.</h2>
          </div>
          <div className="infra-intro-right">
            <p className="infra-intro-desc">Run your business on a reliable platform that adapts to your needs, from your first employee to your ten-thousandth.</p>
          </div>
        </div>
        <div className="infra-intro-products">
          <div className="infra-intro-products-label">Six products. One platform.</div>
          <div className="infra-intro-products-list">
            {[
              { text: 'Process payroll', color: '#FF2D8A' },
              { text: 'Issue wallets', color: '#1D9E75' },
              { text: 'Collect payments', color: '#7F77DD' },
              { text: 'Integrate services', color: '#D85A30' },
              { text: 'Stay compliant', color: '#888780' },
              { text: 'Power AI agents', color: '#4158D0' },
            ].map((p, i) => (
              <div key={i} className="infra-intro-product-pill">
                <span className="infra-intro-product-dot" style={{ background: p.color }} />
                <span>{p.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ═══ 4. PRODUCT BENTO GRID ═══ */}
      <div className="infra-bento" data-testid="infra-bento">
        <div className="infra-bento-row1">
          <Link to="/infrastructure/payroll" className="infra-card infra-card-pink" data-testid="card-payroll">
            <div className="infra-card-header">
              <span className="infra-card-title">Payroll &amp; benefits</span>
              <span className="infra-card-arrow" style={{ color: '#7A2048' }}>{'\u2192'}</span>
            </div>
            <div className="infra-card-desc">Compute salaries, structure benefits, handle tax filing.</div>
            <div className="infra-card-mockup">
              <div className="infra-stat-boxes">
                <div className="infra-stat-box"><div className="infra-stat-box-label">Gross</div><div className="infra-stat-box-value">{'\u20A6'}4.2M</div></div>
                <div className="infra-stat-box"><div className="infra-stat-box-label">Net</div><div className="infra-stat-box-value">{'\u20A6'}3.1M</div></div>
                <div className="infra-stat-box"><div className="infra-stat-box-label">Benefits</div><div className="infra-stat-box-value">{'\u20A6'}1.1M</div></div>
              </div>
            </div>
            <div className="infra-card-sub">Payroll · Benefits · Tax · Offer letters</div>
          </Link>
          <Link to="/infrastructure/wallets" className="infra-card infra-card-green" data-testid="card-wallets">
            <div className="infra-card-header">
              <span className="infra-card-title">Virtual wallets</span>
              <span className="infra-card-arrow" style={{ color: '#1D9E75' }}>{'\u2192'}</span>
            </div>
            <div className="infra-card-desc">Virtual accounts for companies, employees, agents. Move money anywhere.</div>
            <div className="infra-card-mockup">
              <div className="infra-wallet-balance">{'\u20A6'}284,500</div>
              <div className="infra-wallet-account">VA: 8012345678 · Assets MFB</div>
              <div className="infra-wallet-actions">
                <div className="infra-wallet-btn-send">Send</div>
                <div className="infra-wallet-btn-receive">Receive</div>
              </div>
            </div>
            <div className="infra-card-sub">Accounts · Transfers · Ledger · Limits</div>
          </Link>
        </div>
        <div className="infra-bento-row2">
          <Link to="/infrastructure/collect" className="infra-card infra-card-purple" data-testid="card-collect">
            <div className="infra-collect-grid">
              <div>
                <div className="infra-card-header">
                  <span className="infra-card-title">Collect</span>
                  <span className="infra-card-arrow" style={{ color: '#7F77DD' }}>{'\u2192'}</span>
                </div>
                <div className="infra-collect-headline">Stop chasing payments. Deduct at source.</div>
                <div className="infra-collect-desc">Any business that needs recurring payments plugs into Pebbles. Subscriptions, loans, insurance — 99% collection rate.</div>
                <div className="infra-collect-sub">Links · Checkout · SDK · Agent collection</div>
              </div>
              <div className="infra-partners-mockup">
                <div className="infra-partners-label">Collection partners</div>
                <div className="infra-partner-rows">
                  <div className="infra-partner-row">
                    <div><div className="infra-partner-name">Meridian Health</div><div className="infra-partner-sub">Insurance · 342</div></div>
                    <div><div className="infra-partner-amount">{'\u20A6'}1.2M</div><div className="infra-partner-rate">99.1%</div></div>
                  </div>
                  <div className="infra-partner-row">
                    <div><div className="infra-partner-name">StaffCoop</div><div className="infra-partner-sub">Loans · 128</div></div>
                    <div><div className="infra-partner-amount">{'\u20A6'}890K</div><div className="infra-partner-rate">100%</div></div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="infra-bento-row3">
          <Link to="/infrastructure/connect" className="infra-card infra-card-orange" data-testid="card-connect">
            <div className="infra-card-header">
              <span className="infra-card-title">Connect</span>
              <span className="infra-card-arrow" style={{ color: '#D85A30' }}>{'\u2192'}</span>
            </div>
            <div className="infra-card-desc">Build on Pebbles rails. One API, every capability.</div>
            <div className="infra-code-mockup">
              <pre><span className="infra-syn-kw">await</span> pebbles.<span className="infra-syn-fn">create</span>({'{\n'}{'  '}amount: <span className="infra-syn-num">5000</span>{'\n'}{'}'});</pre>
            </div>
            <div className="infra-card-sub">API · Webhooks · SDKs · Marketplace</div>
          </Link>
          <Link to="/infrastructure/comply" className="infra-card infra-card-gray" data-testid="card-comply">
            <div className="infra-card-header">
              <span className="infra-card-title">Comply</span>
              <span className="infra-card-arrow" style={{ color: '#888780' }}>{'\u2192'}</span>
            </div>
            <div className="infra-card-desc">Compliance built in, not bolted on.</div>
            <div className="infra-comply-list">
              {['KYC verified', 'AML passed', 'Audit exported'].map((t, i) => (
                <div key={i} className="infra-comply-item">
                  <div className="infra-comply-check">{'\u2713'}</div>
                  <span className="infra-comply-text">{t}</span>
                </div>
              ))}
            </div>
            <div className="infra-card-sub">KYC · AML · Audit · Reports</div>
          </Link>
          <Link to="/infrastructure/agents" className="infra-card infra-card-blue" data-testid="card-agents">
            <div className="infra-card-header">
              <span className="infra-card-title">Agent wallets</span>
              <span className="infra-card-arrow" style={{ color: '#4158D0' }}>{'\u2192'}</span>
            </div>
            <div className="infra-card-desc">AI agents with spending rules and audit trails.</div>
            <div className="infra-agent-mockup">
              <div className="infra-agent-top">
                <span className="infra-agent-name">Procurement AI</span>
                <span className="infra-agent-badge">Auto</span>
              </div>
              <div className="infra-agent-balance">{'\u20A6'}142,800</div>
              <div className="infra-agent-limit">of {'\u20A6'}500K limit</div>
              <div className="infra-agent-bar-track"><div className="infra-agent-bar-fill" /></div>
            </div>
            <div className="infra-card-sub">Spender · Collector · Rules engine</div>
          </Link>
        </div>
      </div>

      {/* ═══ 5. HOW IT WORKS ═══ */}
      <div className="infra-how" data-testid="infra-how-it-works">
        <div className="infra-how-inner">
          <h2 className="infra-how-headline">How It Works</h2>
          <p className="infra-how-subtitle">Onboard, operate, and scale your financial operations in one platform.</p>
          <div className="infra-how-grid">
            {[
              { step: 'Onboard', items: [
                { icon: '\u2713', label: 'KYC & AML compliant', tint: 'pink' },
                { icon: '\u2709', label: 'Employee accounts', tint: 'pink' },
                { icon: '\u26A1', label: 'Virtual wallet activation', tint: 'pink' },
                { icon: '\u2699', label: 'Benefits enrollment', tint: 'pink' },
              ]},
              { step: 'Operate', items: [
                { icon: '\u20A6', label: 'Process payroll', tint: 'green' },
                { icon: '\u2194', label: 'Internal & external transfers', tint: 'green' },
                { icon: '\u21BB', label: 'Recurring collections', tint: 'green' },
                { icon: '\u2728', label: 'AI agent wallets', tint: 'green' },
              ]},
              { step: 'Scale', items: [
                { icon: '\u2261', label: 'Auto-reconciliation', tint: 'warm' },
                { icon: '\u2191', label: 'Webhook integrations', tint: 'warm' },
                { icon: '\u2263', label: 'Audit-logged exports', tint: 'warm' },
                { icon: '\u25CE', label: 'Multi-company support', tint: 'warm' },
              ]},
            ].map((col, ci) => (
              <div key={ci} className="infra-how-col">
                <h3 className="infra-how-step">{col.step}</h3>
                <div className="infra-how-items">
                  {col.items.map((item, ii) => (
                    <div key={ii} className={`infra-how-item infra-how-item-${item.tint}`}>
                      <span className="infra-how-icon">{item.icon}</span>
                      <span className="infra-how-label">{item.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ═══ 6. PLATFORM OVERVIEW ═══ */}
      <div className="infra-platform" data-testid="infra-platform">
        <div className="infra-platform-grid">
          <div>
            <h2 className="infra-platform-headline">One system for <span className="infra-underline">every</span> financial operation.</h2>
            <p className="infra-platform-desc">Payroll, wallets, collections, transfers, compliance — all sharing the same ledger, the same data, the same employee record. No reconciliation needed.</p>
            <div className="infra-platform-features">
              {['Process payroll and structure benefits', 'Issue wallets and move money', 'Collect recurring payments at source', 'Integrate third parties via API', 'Enforce compliance automatically'].map((f, i) => (
                <div key={i} className="infra-platform-feature">
                  <span className="infra-platform-check">{'\u2713'}</span>
                  <span>{f}</span>
                </div>
              ))}
            </div>
            <Link to="/login" className="infra-platform-cta">Explore the platform {'\u2192'}</Link>
          </div>
          <div className="infra-platform-mockup">
            <div className="infra-platform-wallet-card">
              <div className="infra-platform-wallet-label">Company wallet</div>
              <div className="infra-platform-wallet-balance">{'\u20A6'}2,400,000</div>
            </div>
            <div className="infra-platform-tx-list">
              {[
                { dot: '#FF2D8A', desc: 'Payroll disbursement', amt: '\u20A64.2M' },
                { dot: '#7F77DD', desc: 'Insurance collection', amt: '\u20A61.2M' },
                { dot: '#1D9E75', desc: 'Employee transfer', amt: '\u20A6285K' },
                { dot: '#D85A30', desc: 'API partner payout', amt: '\u20A6450K' },
              ].map((tx, i) => (
                <div key={i} className="infra-platform-tx-row">
                  <div className="infra-platform-tx-left">
                    <div className="infra-platform-tx-dot" style={{ background: tx.dot }} />
                    <span className="infra-platform-tx-desc">{tx.desc}</span>
                  </div>
                  <span className="infra-platform-tx-amt">{tx.amt}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ═══ 7. USE CASES (DARK CARDS) ═══ */}
      <div className="infra-uc-dark" data-testid="infra-use-cases">
        <div className="infra-uc-dark-inner">
          <h2 className="infra-uc-dark-headline">Built for Your Use Cases</h2>
          <div className="infra-uc-dark-grid">
            <div className="infra-uc-dark-card">
              <div className="infra-uc-dark-text">
                <span className="infra-uc-dark-pill" style={{ background: 'rgba(255,45,138,0.15)', color: '#FF2D8A' }}>Employers</span>
                <h3 className="infra-uc-dark-title">Run Payroll &amp; Benefits</h3>
                <p className="infra-uc-dark-desc">Compute salaries, deliver benefits through vendors, handle tax filing, and disburse funds to employee wallets in one workflow.</p>
              </div>
              <div className="infra-uc-dark-mockup">
                <div className="infra-uc-mock-row">
                  <div className="infra-uc-mock-stat"><span className="infra-uc-mock-label">Employees</span><span className="infra-uc-mock-val">24</span></div>
                  <div className="infra-uc-mock-stat"><span className="infra-uc-mock-label">Total</span><span className="infra-uc-mock-val">{'\u20A6'}4.2M</span></div>
                </div>
                <div className="infra-uc-mock-txns">
                  {[
                    { name: 'Adebayo K.', amt: '\u20A6185,000', status: 'Completed' },
                    { name: 'Ngozi O.', amt: '\u20A6220,000', status: 'Completed' },
                    { name: 'Fatima B.', amt: '\u20A6165,000', status: 'Pending' },
                  ].map((t, i) => (
                    <div key={i} className="infra-uc-mock-txn">
                      <span className="infra-uc-mock-txn-name">{t.name}</span>
                      <span className="infra-uc-mock-txn-amt">{t.amt}</span>
                      <span className={`infra-uc-mock-badge ${t.status === 'Completed' ? 'infra-uc-mock-badge-done' : 'infra-uc-mock-badge-pending'}`}>{t.status}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="infra-uc-dark-card">
              <div className="infra-uc-dark-text">
                <span className="infra-uc-dark-pill" style={{ background: 'rgba(127,119,221,0.15)', color: '#7F77DD' }}>Lenders &amp; Cooperatives</span>
                <h3 className="infra-uc-dark-title">Collect at Source</h3>
                <p className="infra-uc-dark-desc">Lenders, insurers, and cooperatives plug into Pebbles to deduct directly from payroll. Zero default risk, guaranteed collection.</p>
              </div>
              <div className="infra-uc-dark-mockup">
                <div className="infra-uc-mock-row">
                  <div className="infra-uc-mock-stat"><span className="infra-uc-mock-label">Partners</span><span className="infra-uc-mock-val">8</span></div>
                  <div className="infra-uc-mock-stat"><span className="infra-uc-mock-label">Collected</span><span className="infra-uc-mock-val">{'\u20A6'}2.1M</span></div>
                </div>
                <div className="infra-uc-mock-txns">
                  {[
                    { name: 'Meridian Health', amt: '\u20A61.2M', status: 'Completed' },
                    { name: 'StaffCoop Loans', amt: '\u20A6890K', status: 'Completed' },
                    { name: 'Unity Insurance', amt: '\u20A6340K', status: 'Completed' },
                  ].map((t, i) => (
                    <div key={i} className="infra-uc-mock-txn">
                      <span className="infra-uc-mock-txn-name">{t.name}</span>
                      <span className="infra-uc-mock-txn-amt">{t.amt}</span>
                      <span className="infra-uc-mock-badge infra-uc-mock-badge-done">{t.status}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="infra-uc-dark-card">
              <div className="infra-uc-dark-text">
                <span className="infra-uc-dark-pill" style={{ background: 'rgba(29,158,117,0.15)', color: '#1D9E75' }}>Platforms &amp; Fintechs</span>
                <h3 className="infra-uc-dark-title">Virtual Wallets for Your Users</h3>
                <p className="infra-uc-dark-desc">Issue wallets to your users, enable peer-to-peer transfers, manage spending limits, and track every transaction in real-time.</p>
              </div>
              <div className="infra-uc-dark-mockup">
                <div className="infra-uc-mock-row">
                  <div className="infra-uc-mock-stat"><span className="infra-uc-mock-label">Wallets</span><span className="infra-uc-mock-val">1,247</span></div>
                  <div className="infra-uc-mock-stat"><span className="infra-uc-mock-label">Volume</span><span className="infra-uc-mock-val">{'\u20A6'}18M</span></div>
                </div>
                <div className="infra-uc-mock-txns">
                  {[
                    { name: 'P2P transfer', amt: '\u20A645,000', status: 'Completed' },
                    { name: 'Wallet top-up', amt: '\u20A6100,000', status: 'Completed' },
                    { name: 'Vendor payout', amt: '\u20A6285,000', status: 'Completed' },
                  ].map((t, i) => (
                    <div key={i} className="infra-uc-mock-txn">
                      <span className="infra-uc-mock-txn-name">{t.name}</span>
                      <span className="infra-uc-mock-txn-amt">{t.amt}</span>
                      <span className="infra-uc-mock-badge infra-uc-mock-badge-done">{t.status}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="infra-uc-dark-card">
              <div className="infra-uc-dark-text">
                <span className="infra-uc-dark-pill" style={{ background: 'rgba(216,90,48,0.15)', color: '#D85A30' }}>App Developers &amp; SaaS</span>
                <h3 className="infra-uc-dark-title">Embed Payments in Your App</h3>
                <p className="infra-uc-dark-desc">Integrate the Pebbles SDK. Let users pay with their wallet. Collect subscriptions, process payouts, and manage billing via API.</p>
              </div>
              <div className="infra-uc-dark-mockup">
                <div className="infra-uc-mock-row">
                  <div className="infra-uc-mock-stat"><span className="infra-uc-mock-label">API calls</span><span className="infra-uc-mock-val">12K</span></div>
                  <div className="infra-uc-mock-stat"><span className="infra-uc-mock-label">Success</span><span className="infra-uc-mock-val">99.8%</span></div>
                </div>
                <div className="infra-uc-mock-txns">
                  {[
                    { name: 'SDK checkout', amt: '\u20A625,000', status: 'Completed' },
                    { name: 'Subscription', amt: '\u20A65,000/mo', status: 'Completed' },
                    { name: 'API payout', amt: '\u20A6450,000', status: 'Completed' },
                  ].map((t, i) => (
                    <div key={i} className="infra-uc-mock-txn">
                      <span className="infra-uc-mock-txn-name">{t.name}</span>
                      <span className="infra-uc-mock-txn-amt">{t.amt}</span>
                      <span className="infra-uc-mock-badge infra-uc-mock-badge-done">{t.status}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ═══ 8. DEVELOPER SECTION (DARK) ═══ */}
      <div className="infra-dev" data-testid="infra-dev">
        <div className="infra-dev-grid">
          <div>
            <div className="infra-dev-eyebrow">DEVELOPERS</div>
            <h2 className="infra-dev-headline">Ship in <span className="infra-underline">hours</span>, not months.</h2>
            <p className="infra-dev-desc">Clean REST endpoints, predictable responses, comprehensive webhooks, SDKs in every major language.</p>
            <div className="infra-dev-features">
              {['Consistent JSON responses', 'Webhooks for every event type', 'Sandbox with test credentials', 'Idempotency keys on all writes'].map((f, i) => (
                <div key={i} className="infra-dev-feature">
                  <div className="infra-dev-dot" />
                  <span>{f}</span>
                </div>
              ))}
            </div>
            <Link to="/infrastructure/developers" className="infra-dev-cta">Read the docs {'\u2192'}</Link>
          </div>
          <div className="infra-dev-code">
            <pre>
<span className="infra-syn-cmt">{'// Create wallet + fund + collect'}</span>{'\n'}
{'\n'}
<span className="infra-syn-kw">const</span> wallet = <span className="infra-syn-kw">await</span> pebbles.<span className="infra-syn-fn">create</span>({'{'}
{'\n'}{'  '}owner: <span className="infra-syn-str">'emp_adebayo'</span>,
{'\n'}{'  '}tier: <span className="infra-syn-num">2</span>
{'\n'}{'}'});
{'\n'}
{'\n'}
<span className="infra-syn-kw">await</span> pebbles.transfers.<span className="infra-syn-fn">send</span>({'{'}
{'\n'}{'  '}to: wallet.id,
{'\n'}{'  '}amount: <span className="infra-syn-num">285000</span>,
{'\n'}{'  '}ref: <span className="infra-syn-str">'PAYROLL-MAR'</span>
{'\n'}{'}'});
{'\n'}
{'\n'}
<span className="infra-syn-kw">await</span> pebbles.collect.<span className="infra-syn-fn">subscribe</span>({'{'}
{'\n'}{'  '}plan: <span className="infra-syn-str">'health_monthly'</span>,
{'\n'}{'  '}amount: <span className="infra-syn-num">5000</span>
{'\n'}{'}'});
            </pre>
          </div>
        </div>
      </div>

      {/* ═══ 9. MASSIVE STATS ═══ */}
      <div className="infra-big-stats" data-testid="infra-stats">
        <div className="infra-big-stats-inner">
          <div className="infra-big-stats-grid">
            {[
              { num: '99.9%', label: 'Platform Uptime' },
              { num: 'One API', label: 'Across All Products' },
              { num: '< 3s', label: 'Transfer Speed' },
            ].map((s, i) => (
              <div key={i} className="infra-big-stat">
                <div className="infra-big-stat-divider" />
                <div className="infra-big-stat-num">{s.num}</div>
                <div className="infra-big-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ═══ 10. DEVELOPER SHOWCASE ═══ */}
      <div className="infra-devshow" data-testid="infra-devshow">
        <div className="infra-devshow-inner">
          <h2 className="infra-devshow-headline">Choose your integration path</h2>
          <p className="infra-devshow-desc">Dashboard, pre-built connectors, or full API — start building in minutes.</p>
          <div className="infra-devshow-grid">
            <Link to="/infrastructure/developers" className="infra-devshow-card" data-testid="devshow-dashboard">
              <div className="infra-devshow-visual infra-devpage-visual-dashboard">
                <div className="infra-devpage-dash-topbar">
                  <div className="infra-devpage-dash-dot" style={{background:'#ff5f57'}} />
                  <div className="infra-devpage-dash-dot" style={{background:'#febc2e'}} />
                  <div className="infra-devpage-dash-dot" style={{background:'#28c840'}} />
                  <span className="infra-devpage-dash-url">app.pebbles.financial</span>
                </div>
                <div className="infra-devpage-dash-body">
                  <div className="infra-devpage-dash-sidebar">
                    <div className="infra-devpage-dash-sidebar-item infra-devpage-dash-sidebar-active">Payroll</div>
                    <div className="infra-devpage-dash-sidebar-item">Wallets</div>
                    <div className="infra-devpage-dash-sidebar-item">Collect</div>
                    <div className="infra-devpage-dash-sidebar-item">Settings</div>
                  </div>
                  <div className="infra-devpage-dash-main">
                    <div className="infra-devpage-dash-heading">Run payroll</div>
                    <div className="infra-devpage-dash-row">
                      <div className="infra-devpage-dash-field">
                        <span className="infra-devpage-dash-label">Employees</span>
                        <span className="infra-devpage-dash-value">24</span>
                      </div>
                      <div className="infra-devpage-dash-field">
                        <span className="infra-devpage-dash-label">Total</span>
                        <span className="infra-devpage-dash-value">{'\u20A6'}4.2M</span>
                      </div>
                    </div>
                    <div className="infra-devpage-dash-btn">Process payroll</div>
                  </div>
                </div>
              </div>
              <div className="infra-devshow-text">
                <span className="infra-devshow-bold">No code required.</span> Run payroll, manage wallets, and view compliance from the dashboard.
              </div>
            </Link>

            <Link to="/infrastructure/developers" className="infra-devshow-card" data-testid="devshow-partners">
              <div className="infra-devshow-visual infra-devpage-visual-partners">
                <div className="infra-devpage-partner-grid">
                  {[
                    { name: 'BambooHR', color: '#73c41d', letter: 'B' },
                    { name: 'Workday', color: '#0075c9', letter: 'W' },
                    { name: 'Slack', color: '#611f69', letter: 'S' },
                    { name: 'Xero', color: '#13b5ea', letter: 'X' },
                    { name: 'QuickBooks', color: '#2ca01c', letter: 'Q' },
                    { name: 'Gusto', color: '#f45d48', letter: 'G' },
                    { name: 'Zoho', color: '#e42527', letter: 'Z' },
                    { name: 'SAP', color: '#008fd3', letter: 'S' },
                  ].map((p, i) => (
                    <div key={i} className="infra-devpage-partner-tile">
                      <div className="infra-devpage-partner-icon" style={{ background: p.color }}>{p.letter}</div>
                      <span className="infra-devpage-partner-name">{p.name}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="infra-devshow-text">
                <span className="infra-devshow-bold">Pre-built connectors.</span> Integrate with BambooHR, Workday, Xero, and 20+ platforms.
              </div>
            </Link>

            <Link to="/infrastructure/developers" className="infra-devshow-card" data-testid="devshow-api">
              <div className="infra-devshow-visual infra-devpage-visual-code">
                <div className="infra-devpage-code-editor">
                  <div className="infra-devpage-code-lines">
                    <pre>
                      <span className="infra-devpage-ln">1</span>  <span className="infra-syn-kw">const</span> pebbles = <span className="infra-syn-fn">require</span>(<span className="infra-syn-str">'pebbles'</span>)(
                      {'\n'}<span className="infra-devpage-ln">2</span>    <span className="infra-syn-str">'sk_live_...'</span>
                      {'\n'}<span className="infra-devpage-ln">3</span>  );
                      {'\n'}<span className="infra-devpage-ln">4</span>
                      {'\n'}<span className="infra-devpage-ln">5</span>  <span className="infra-syn-kw">await</span> pebbles.wallets.<span className="infra-syn-fn">create</span>({'{'}
                      {'\n'}<span className="infra-devpage-ln">6</span>    owner: <span className="infra-syn-str">'emp_9x2kf4'</span>,
                      {'\n'}<span className="infra-devpage-ln">7</span>    tier: <span className="infra-syn-num">2</span>
                      {'\n'}<span className="infra-devpage-ln">8</span>  {'}'});
                    </pre>
                  </div>
                  <div className="infra-devpage-code-autocomplete">
                    <div className="infra-devpage-ac-item">wallets.create</div>
                    <div className="infra-devpage-ac-item infra-devpage-ac-highlight">wallets.fund</div>
                    <div className="infra-devpage-ac-item">transfers.send</div>
                    <div className="infra-devpage-ac-item">collect.subscribe</div>
                  </div>
                  <div className="infra-devpage-code-terminal">
                    <div className="infra-devpage-term-bar">
                      <span className="infra-devpage-term-label">TERMINAL</span>
                    </div>
                    <div className="infra-devpage-term-body">
                      <div className="infra-devpage-term-ready">&gt; Wallet created: wal_8x9f2k</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="infra-devshow-text">
                <span className="infra-devshow-bold">Full API access.</span> REST APIs, webhooks, SDKs, and a sandbox environment.
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* ═══ 11. READY TO BUILD — CONTACT FORM (DARK) ═══ */}
      <div className="infra-contact-dark" data-testid="infra-contact">
        <div className="infra-contact-dark-inner">
          <div className="infra-contact-dark-left">
            <h2 className="infra-contact-dark-headline">Ready to build?</h2>
            <p className="infra-contact-dark-desc">Tell us about your use case and we'll show you how Pebbles fits your roadmap.</p>
            <div className="infra-contact-dark-points">
              <div className="infra-contact-dark-point">
                <div className="infra-contact-dark-check">{'\u2713'}</div>
                <span>Talk to a product specialist</span>
              </div>
              <div className="infra-contact-dark-point">
                <div className="infra-contact-dark-check">{'\u2713'}</div>
                <span>Custom pricing for your scale</span>
              </div>
              <div className="infra-contact-dark-point">
                <div className="infra-contact-dark-check">{'\u2713'}</div>
                <span>Live demo of the full platform</span>
              </div>
            </div>
          </div>
          <div className="infra-contact-dark-form">
            <div className="infra-contact-dark-row">
              <div className="infra-contact-dark-field">
                <label className="infra-contact-dark-label">First name</label>
                <input className="infra-contact-dark-input" data-testid="contact-first-name" placeholder="Jane" value={form.firstName} onChange={e => setForm({...form, firstName: e.target.value})} />
              </div>
              <div className="infra-contact-dark-field">
                <label className="infra-contact-dark-label">Last name</label>
                <input className="infra-contact-dark-input" data-testid="contact-last-name" placeholder="Doe" value={form.lastName} onChange={e => setForm({...form, lastName: e.target.value})} />
              </div>
            </div>
            <div className="infra-contact-dark-field">
              <label className="infra-contact-dark-label">Work email</label>
              <input className="infra-contact-dark-input" data-testid="contact-email" type="email" placeholder="jane@company.com" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
            </div>
            <div className="infra-contact-dark-field">
              <label className="infra-contact-dark-label">Company</label>
              <input className="infra-contact-dark-input" data-testid="contact-company" placeholder="Your company name" value={form.company} onChange={e => setForm({...form, company: e.target.value})} />
            </div>
            <div className="infra-contact-dark-field">
              <label className="infra-contact-dark-label">Product interest</label>
              <select className="infra-contact-dark-select" data-testid="contact-product" value={form.product} onChange={e => setForm({...form, product: e.target.value})}>
                <option value="">Select a product</option>
                <option value="payroll">Payroll &amp; Benefits</option>
                <option value="wallets">Virtual Wallets</option>
                <option value="collect">Collect</option>
                <option value="connect">Connect (API)</option>
                <option value="comply">Comply</option>
                <option value="agents">Agent Wallets</option>
                <option value="platform">Full Platform</option>
              </select>
            </div>
            <a href="mailto:hello@thcohq.com" className="infra-contact-dark-submit" data-testid="contact-submit">Talk to us {'\u2192'}</a>
          </div>
        </div>
      </div>

      {/* ═══ 11. FOOTER ═══ */}
      <footer className="infra-footer" data-testid="infra-footer">
        <div className="infra-footer-grid">
          <div>
            <div className="infra-footer-brand">Pebbles</div>
            <div className="infra-footer-tagline">The financial OS companies build on.</div>
          </div>
          <div>
            <div className="infra-footer-heading">PRODUCTS</div>
            <Link to="/infrastructure/payroll" className="infra-footer-link">Payroll &amp; Benefits</Link>
            <Link to="/infrastructure/wallets" className="infra-footer-link">Virtual Wallets</Link>
            <Link to="/infrastructure/collect" className="infra-footer-link">Collect</Link>
            <Link to="/infrastructure/connect" className="infra-footer-link">Connect</Link>
            <Link to="/infrastructure/comply" className="infra-footer-link">Comply</Link>
            <Link to="/infrastructure/agents" className="infra-footer-link">Agent Wallets</Link>
          </div>
          <div>
            <div className="infra-footer-heading">DEVELOPERS</div>
            <Link to="/infrastructure/developers" className="infra-footer-link">Documentation</Link>
            <Link to="/infrastructure/developers" className="infra-footer-link">API reference</Link>
            <Link to="/infrastructure/developers" className="infra-footer-link">SDKs</Link>
            <Link to="/infrastructure/developers" className="infra-footer-link">Webhooks</Link>
          </div>
          <div>
            <div className="infra-footer-heading">COMPANY</div>
            <a href="mailto:hello@thcohq.com" className="infra-footer-link">About</a>
            <a href="mailto:hello@thcohq.com" className="infra-footer-link">Blog</a>
            <a href="mailto:hello@thcohq.com" className="infra-footer-link">Careers</a>
            <a href="mailto:hello@thcohq.com" className="infra-footer-link">Security</a>
          </div>
        </div>
      </footer>
      <div className="infra-bottom" data-testid="infra-bottom-bar">
        <span className="infra-bottom-text">{'\u00A9'} 2026 THCO</span>
        <span className="infra-bottom-text">pebbles.financial</span>
      </div>
    </div>
  );
}
